import { Content, Header } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import IMAGES from "../const/Image";
import {
  Button,
  Card,
  Dropdown,
  Layout,
  Menu,
  Space,
  notification,
} from "antd";
import API_URL from "../api/url";

import {
  DiffOutlined,
  LogoutOutlined,
  DownOutlined,
  UserOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import Sider from "antd/es/layout/Sider";
import { Outlet, useNavigate } from "react-router-dom";
import API_URLS from "../api/url";
import { login } from "../Services/AuthServices";

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [userName, setUserName] = useState("");

  const handleMouseEnter = () => {
    setCollapsed(false);
    // setHoveredItem(key);
  };

  const handleMouseLeave = () => {
    setCollapsed(true);
    setHoveredItem(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    setUserName("");
    navigate("/");
  };

  // const items = [
  //   // {
  //   //   label: 'Profile',
  //   //   key: '1',
  //   //   icon: <UserOutlined />,
  //   // },
  //   {
  //     label: 'Logout',
  //     key: '1',
  //     icon: <LogoutOutlined />,
  //     onClick: handleLogout,
  //   },

  // ];
  //  const userMenu = () => (
  //     <Menu>
  //       {/* <Menu.Item icon={<SettingOutlined />}>Setting</Menu.Item> */}
  //       <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={() => navigate("/")}>
  //         Logout
  //       </Menu.Item>
  //     </Menu>
  //   );
  // const menuProps = {
  //   items,
  // };

  useEffect(() => {
    const loginName = localStorage.getItem("Name");
    setUserName(loginName);
  }, []);

  return (
    <>
      <div className="dashboard-container">
        <Header className=" header-admin" style={{ padding: 0 }}>
          <div className=" bg-header">
            <img src={IMAGES.TaxiLogo} className="BMBLogo" alt="" />
            <div className=" head-r-logo">
              <div className=" header-menu">
                <div>
                  <Button>
                    {/* Administrator   */}
                    {userName ? userName : "Loading..."}
                  </Button>
                  {/* <Dropdown menu={menuProps}>
                    
                  </Dropdown> */}
                </div>
              </div>
            </div>
          </div>
        </Header>
        <Layout className="layout_css">
          <Sider
            trigger={null}
            collapsible={false}
            collapsed={collapsed}
            className={collapsed ? "layoutSiderHovered" : "layoutSider"}
            onMouseEnter={() => handleMouseEnter(null)}
            onMouseLeave={handleMouseLeave}
          >
            <Menu
              style={{
                display: "flex",
                gap: "0px",
                flexDirection: "column",
                paddingLeft: "0px",
                paddingRight: "0px",
                borderInlineEnd: "0px",
              }}
              theme="light"
              mode="inline"
              items={[
                {
                  key: "dashboard",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.HomeIcon} alt="" />
                    </span>
                  ),
                  label: "Dashboard",
                  onClick: () => {
                    navigate("/dashboard");
                  },
                },
                {
                  key: "User Management",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.UserManagementIcon} alt="" />
                    </span>
                  ),
                  label: "User Management",
                  onClick: () => {
                    navigate("/user-management/users");
                  },
                },
                {
                  key: "Booking Management",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.BookingManage} alt="" />
                    </span>
                  ),
                  label: "Booking Management",
                  children: [
                    {
                      key: "bookingStatus",
                      label: (
                        <span style={{ fontSize: "15px" }}>Booking Status</span>
                      ),
                      icon: (
                        <span className="icon-bg sub-icon">
                          <img src={IMAGES.BookingStatus} alt="" />
                        </span>
                      ),
                      onClick: () => {
                        navigate("/booking-management/bookingStatus");
                      },
                    },
                    {
                      key: "bookings",
                      label: (
                        <span style={{ fontSize: "15px" }}>Manage Booking</span>
                      ),
                      icon: (
                        <span className="icon-bg sub-icon">
                          <img src={IMAGES.Booking} alt="" />
                        </span>
                      ),
                      onClick: () => {
                        navigate("/booking-management/bookings");
                      },
                    },
                  ],
                },

                {
                  key: "Other Master",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.OtherMaster} alt="" />
                    </span>
                  ),
                  label: "Other Master",
                  children: [
                    {
                      key: "manageVendor",
                      label: (
                        <span style={{ fontSize: "15px" }}>Manage Vendor</span>
                      ),
                      icon: (
                        <span className="icon-bg sub-icon">
                          <img src={IMAGES.OtherMaster} alt="" />
                        </span>
                      ),
                      onClick: () => {
                        navigate("/other-master/vendors");
                      },
                    },
                    {
                      key: "manageDriver",
                      label: (
                        <span style={{ fontSize: "15px" }}>Manage Driver</span>
                      ),
                      icon: (
                        <span className="icon-bg sub-icon">
                          <img src={IMAGES.OtherMaster} alt="" />
                        </span>
                      ),
                      onClick: () => {
                        navigate("/other-master/drivers");
                      },
                    },
                    {
                      key: "manageCars",
                      label: (
                        <span style={{ fontSize: "15px" }}>Manage Cars</span>
                      ),
                      icon: (
                        <span className="icon-bg sub-icon">
                          <img src={IMAGES.OtherMaster} alt="" />
                        </span>
                      ),
                      onClick: () => {
                        navigate("/other-master/cars");
                      },
                    },
                  ],
                },
                {
                  key: "privacyPolicy",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.privacy} alt="" />
                    </span>
                  ),
                  label: "Privacy Policy",
                  onClick: () => {
                    navigate("/policies");
                  },
                },
                {
                  key: "TermsandCondition",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.termscondition} alt="" />
                    </span>
                  ),
                  label: "Terms & Condition",
                  onClick: () => {
                    navigate("/termsConditions");
                  },
                },
                {
                  key: "PanaltyStructure",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.panaltystructure} alt="" />
                    </span>
                  ),
                  label: "Panalty Structure",
                  onClick: () => {
                    navigate("/panaltyStructures");
                  },
                },
                {
                  key: "logout",
                  icon: (
                    <span className="icon-bg">
                      <img src={IMAGES.logout} alt="" />
                    </span>
                  ),
                  label: "Logout",
                  onClick: handleLogout,
                },
              ]}
            />
          </Sider>
          <Layout className="dslr-web bmb-wrapper">
            <Content
              className="content-shado"
              style={{
                minHeight: "220px",
                maxHeight: "85%",
                overflowY: "scroll",
              }}
            >
              <Card>
                <Outlet />
              </Card>
            </Content>
          </Layout>
        </Layout>
      </div>
    </>
  );
};

export default MainLayout;
